import { render, staticRenderFns } from "./UpdateUploadsPage.vue?vue&type=template&id=2c4a3d92&"
import script from "./UpdateUploadsPage.vue?vue&type=script&lang=js&"
export * from "./UpdateUploadsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports